export default {"src":"/_next/static/media/aqn-logo-long-dark.0ebf3253.svg","height":300,"width":840,"blurWidth":0,"blurHeight":0};